module.exports = __webpack_public_path__ + "static/media/fig_13c2.8101509a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13c2.jpg
// module id = 637
// module chunks = 0